import './utils/polyfills';
import './styles/app.scss';
import { fetchEnv } from './env';
import { lazy, useEffect, useState } from 'react';
import LoaderProgressRing from './components/common/LoaderProgressRing';
import { BaseRouteDefinition, browserHistory, HomepageRoute, pushState, getNavigableRoute } from './helpers/navigator';
import { createNavigationListener, isInExoSkeleton } from '@adsk/exo-skeleton-api';

const App = () => {
  const [isEnvFeched, setIsEnvFeched] = useState(false);
  const [AppBase, setAppBase] = useState(null);

  const isInExo = isInExoSkeleton();

  useEffect(() => {
    let listener;

    if (isInExo) {
      listener = createNavigationListener({
        onNavigate({ data }) {
          if (data.to === getNavigableRoute(BaseRouteDefinition)) {
            pushState(HomepageRoute());
          }
        },
      });
    }

    return () => listener && listener.dispose();
  }, [isInExo]);

  useEffect(() => {
    if (!isEnvFeched) {
      fetchEnv().then(() => {
        const appBase = lazy(() => import('./components/AppBase'));
        setAppBase(appBase);
        setIsEnvFeched(true);
      });
    }

    return () => {
      const prevLocation = browserHistory?.location?.pathname;
      const currentLocation = window.location.pathname;

      if (prevLocation !== currentLocation) {
        pushState(currentLocation);
      }
    };
  }, [isEnvFeched]);

  return isEnvFeched ? <AppBase /> : <LoaderProgressRing />;
};

export default App;
